import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Rooms',
  icon: 'image',
  type: 'rooms',
  tag: 'setup & tools',
  content: {
    cardSize: '4',
    verticalSpacing: {
      top: '0',
      bottom: 'md',
    },
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
